module.exports = __webpack_public_path__ + "img/bot-top-2.68831cf5.png";